import { useEffect, useState, forwardRef } from "react";
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const FuelFromAutoComplete = forwardRef((props, ref) => {
    const { allOption, selectedValues = [], disabled = false, prevId, nextId, isFormikFormField = false, showFormError = false, ...rest } = props;
    const fuelFromOptions = [{ label: 'Fuel Store', id: 1 }, { label: 'Fuel Station', id: 2 }];
    let initialProps = {
        ...rest,
        labelKey: 'label',
        primaryKey: 'id',
        options: fuelFromOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        dataLoaded: false,
        disabled,
        prevId, 
        nextId
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);

    useEffect(() => {
        if (selectedValues.length > 0) {
            let preSelectedValues = [];
            if (selectedValues.length > 0) {
                preSelectedValues = fuelFromOptions.filter((s) => selectedValues.indexOf(s.id) >= 0);
                const newProps = { ...defaultProps, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValues]);

    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true }
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((i) => selectedValues.indexOf(i.id) >= 0);
        }
        setDefaultProps({ ...defaultProps, nextId, prevId, preSelectedValues, dataLoaded: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextId, prevId]);

    return (defaultProps.dataLoaded ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default FuelFromAutoComplete
